import {
  BgColors,
  Colors,
  ModCfBgColors,
  ModCfColors,
} from "types/generic/types";
import {
  CfIconNames,
  ModCfFileImage,
  ModCfIconNames,
} from "types/cf-utils/types";
import { ImageProps } from "components/Image/types";
import { Infer, boolean, enums, nullable, object, string } from "superstruct";

export const ModCfImageIcon = object({
  __typename: enums(["ContentfulIconV2"]),
  contentful_id: string(),
  id: string(),
  iconType: enums(["svgDesign", "image"]),
  svgLibrary: nullable(ModCfIconNames),
  svgColor: nullable(ModCfColors),
  svgBackground: nullable(ModCfBgColors),
  svgTypeImage: nullable(boolean()),
  imageFile: nullable(ModCfFileImage),
  alt: nullable(string()),
  customClass: nullable(string()),
});

export type CfImageIconProps = Infer<typeof ModCfImageIcon>;

export interface ImageIconProps {
  __typename?: "ContentfulIconV2";
  contentful_id?: string;
  id?: string;
  alt?: string | null;
  customClass?: string | null;
  iconType: "svgDesign" | "image";
  svgLibrary?: CfIconNames | null;
  svgColor?: Colors | null;
  svgBackground?: BgColors | null;
  svgTypeImage?: boolean | null;
  image?: ImageProps | null;
}
